import { useEffect, useState } from 'react';
import Icon from './Icon';

// "More" overflow dropdown (FILTER_AND_DATE_RULES.md §3). Hosts the
// less-used categorical filters that don't earn a first-class slot in
// the bar. The trigger is a .docs-filter-control pill; the panel below
// renders whatever children are passed. The count badge shows the
// number of filters inside that are currently active.
//
// `activeCount` is computed by the parent — knowing which children
// are "active" requires reading their state, which the parent already
// owns, so we keep this component dumb.
export default function MoreFilters({ activeCount = 0, children }) {
  const [open, setOpen] = useState(false);
  const isActive = activeCount > 0;

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open]);

  return (
    <div className="more-filters">
      <button
        type="button"
        className={`docs-filter-control${isActive ? ' is-active' : ''}`}
        onClick={() => setOpen(o => !o)}
        aria-expanded={open}
        aria-haspopup="true"
        style={{ cursor: 'pointer' }}
      >
        {/* "Tune" icon (3 lines with slider knobs) — matches the More-button
            convention in the FILTER_AND_DATE_RULES.md reference design. */}
        <span className="more-filters-icon" aria-hidden="true">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" strokeWidth="2"
               strokeLinecap="round" strokeLinejoin="round">
            <line x1="4" y1="6"  x2="20" y2="6" />
            <line x1="4" y1="12" x2="20" y2="12" />
            <line x1="4" y1="18" x2="20" y2="18" />
            <circle cx="9"  cy="6"  r="2.2" fill="currentColor" stroke="none" />
            <circle cx="15" cy="12" r="2.2" fill="currentColor" stroke="none" />
            <circle cx="9"  cy="18" r="2.2" fill="currentColor" stroke="none" />
          </svg>
        </span>
        <span className="docs-filter-microlabel">עוד</span>
        {isActive && (
          <span className="multi-select-count">{activeCount}</span>
        )}
        <Icon name="chevron" size={12} className="docs-filter-caret" />
      </button>

      {open && (
        <>
          <div className="menu-backdrop" onClick={() => setOpen(false)} />
          <div className="more-filters-panel">
            {children}
            <div className="more-filters-footer">
              <button
                type="button"
                className="multi-select-done"
                onClick={() => setOpen(false)}
              >
                סיום
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
